import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { ACCOUNT_SALES_MODULE, SALE_COLUMN, SALE_MCI_COLUMN } from "../constants/accountSettingsConstants";

const domain = window.location.host.split('.')[1];
const saleColumns = (): Column[] => domain === 'tripmci' ? SALE_MCI_COLUMN : SALE_COLUMN;

export const setSalePreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: ACCOUNT_SALES_MODULE,
        default_columns: saleColumns(),
        default_order_by: '',
        default_order: 'asc',
    });
